<style scoped>

  @media only screen and (min-width: 991px) {
    .inline.fields {
      margin-top: -15px !important;
    }
  }  

  .payment-cond-segment {
    min-height: 210px;
  }

</style>

<template>

  <div>

    <div class="ui large breadcrumb">
      <back-button-link label="Clínicas" :to="indexRoute" />
      <i class="right chevron icon divider"></i>
      <div class="section">
        <strong>{{ isCreating ? creatingTitle : updatingTitle }}</strong>
      </div>
    </div>

    <bookmark-button v-if="isCreating" :label="creatingTitle" />

    <div class="ui divider"></div>

    <div v-if="loading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

    <div v-show="!loading" class="animated fadeIn">      

      <div class="ui segment form-segment">
        <h4 class="ui dividing header">Dados Cadastrais</h4>
        <div class="ui form">
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Pessoa</label> 
            </div> 
          </div>
          <div class="inline fields">
            <div class="field">
              <div class="ui radio checkbox customer-form-checkbox">
                <input type="radio" class="hidden" value="J" v-model="customer.person" @change="customer.cgc = ''">
                <label><i class="building outline red icon"></i>Jurídica</label>
              </div>
            </div>
            <div class="field">
              <div class="ui radio checkbox customer-form-checkbox m-l-10">
                <input type="radio" class="hidden" value="F" v-model="customer.person" @change="customer.cgc = ''">
                <label><i class="user outline blue icon"></i>Física</label>
              </div>
            </div>
          </div>
          <div class="fields">
            <div class="eight wide field">
              <label class="form-label">{{ customer.person == 'J' ? 'Razão Social' : 'Nome Completo' }} <span class="red text">*</span></label>
              <input class="uppercase" v-model="customer.name" @blur="customer.name = $toUpperCase($event)">
            </div>         
            <div class="five wide field">
              <label class="form-label">{{ customer.person == 'J' ? 'Nome Fantasia' : 'Nome Reduzido' }} <span class="red text">*</span></label>
              <input class="uppercase" v-model="customer.shortName" @blur="customer.shortName = $toUpperCase($event)">
            </div>         
            <div class="three wide field animated fadeIn">
              <label class="form-label">{{ customer.person == 'J' ? 'CNPJ' : 'CPF' }}</label>
              <the-mask type="tel" :mask="['##.###.###/####-##', '###.###.###-##']" v-model="customer.cgc" />
            </div>                
          </div>          
          <div class="fields">
            <div class="four wide field animated fadeIn">
              <label class="form-label">CEP</label>
              <the-mask type="tel" :mask="'#####-###'" v-model="customer.zipCode" @blur.native="loadAddressByZipCode()" />
            </div>
            <div class="seven wide field">
              <label class="form-label">Logradouro</label>
              <input class="uppercase" placeholder="Rua, Avenida, Praça, etc." v-model="customer.address" @blur="customer.address = $toUpperCase($event)">
            </div>
            <div class="two wide field">
              <label class="form-label">Número</label>
              <input class="uppercase" v-model="customer.number" @blur="customer.number = $toUpperCase($event)">
            </div>
            <div class="three wide field">
              <label class="form-label">Complemento</label>
              <input class="uppercase" v-model="customer.complement" @blur="customer.complement = $toUpperCase($event)">
            </div>            
          </div>
          <div class="fields">            
            <div class="four wide field">
              <label class="form-label">Bairro</label>
              <input class="uppercase" v-model="customer.district" @blur="customer.district = $toUpperCase($event)">
            </div>
            <div class="seven wide field">
              <label class="form-label">Município</label>
              <input class="uppercase" v-model="customer.city" @blur="customer.city = $toUpperCase($event)">
            </div>
            <div class="five wide field">
              <label class="form-label">Estado</label>
              <select-state ref="selectState" @onChange="onChangeState" />
            </div>                        
          </div>
          <div class="fields">
            <div class="four wide field">
              <label class="form-label">Telefone 1</label>
              <input type="tel" v-model="customer.phone">
            </div>   
            <div class="four wide field">
              <label class="form-label">Telefone 2</label>
              <input type="tel" v-model="customer.phone2">
            </div>
            <div class="four wide field">
              <label class="form-label">Celular 1</label>
              <input type="tel" v-model="customer.mobile">
            </div>                                      
            <div class="four wide field">
              <label class="form-label">Celular 2</label>
              <input type="tel" v-model="customer.mobile2">
            </div>                                                   
          </div>
          <div class="fields">
            <div class="four wide field">
              <label class="form-label">E-mail Geral</label>
              <input type="email" v-model="customer.email" @blur="customer.email = $clearEmail($event)">
            </div>
            <div class="four wide field">
              <label class="form-label">E-mail Financeiro</label>
              <input type="email" v-model="customer.financialEmail" @blur="customer.financialEmail = $clearEmail($event)">
            </div>
            <div v-if="customer.person == 'J'" class="four wide field animated fadeIn">
              <label class="form-label">Inscrição Municipal</label>
              <input v-model="customer.cityRegistration">
            </div>   
          </div>
        </div>
      </div>

      <div class="ui segment">

        <h4 class="ui dividing header">Conta Bancária</h4>
        
        <div class="ui form">
          <div class="fields">
            <div class="three wide field">
              <label class="form-label">CNPJ / CPF</label>
              <the-mask type="tel" :mask="['##.###.###/####-##', '###.###.###-##']" v-model="customer.bankCgc" />
            </div>
            <div class="five wide field">
              <label class="form-label">Banco</label>
              <select-bank ref="selectBank" @onChange="onChangeBank" />
            </div>
            <div class="two wide field">
              <label class="form-label">Agência</label>
              <input v-model="customer.bankAgency">
            </div>
            <div class="four wide field">
              <label class="form-label">Conta</label>
              <input v-model="customer.bankAccount">
            </div>   
            <div class="two wide field">
              <label class="form-label">DV Conta</label>
              <input v-model="customer.bankAccountDigit" maxlength="1">
            </div>   
          </div>
        </div>

      </div>    

      <div class="ui segment form-segment">

        <h4 class="ui dividing header">Contatos</h4>

        <button class="ui mini basic button" @click="$refs.contactModal.create()">
          <i class="plus blue icon"></i> Adicionar
        </button>        
        
        <table v-if="hasContacts" class="ui celled selectable tablet stackable table animated fadeIn">
          <thead v-if="$isDesktop">
            <tr>
              <th>Nome</th>
              <th>Departamento</th>
              <th>E-mail</th>
              <th>Telefone</th>
              <th>Celular</th>
              <th></th>
            </tr>  
          </thead>
          <tbody>
            <tr v-if="!contact.removed" v-for="(contact, index) in customer.contacts" @click="onContactClick(index)">
              <td>
                <strong class="mobile-only">Nome: </strong> {{ contact.name }}                  
              </td>
              <td>
                <strong class="mobile-only">Departamento: </strong> {{ contact.department }}  
              </td>   
              <td>
                <strong class="mobile-only">E-mail: </strong> {{ contact.email }}   
              </td>
              <td>
                <strong class="mobile-only">Telefone: </strong> {{ contact.phone }}
              </td>   
              <td>
                <strong class="mobile-only">Celular: </strong> {{ contact.mobile }}
              </td>   
              <td style="width: 50px;">
                <button class="ui small icon button" @click="onRemoveContact($event, index)">
                  <i class="times icon"></i>
                </button>
              </td>
            </tr>                
          </tbody>
        </table>

        <p v-else class="grey text m-t-20 animated fadeIn">
          <i class="info circle icon"></i> Nenhum contato adicionado
        </p>

      </div>  

      <div class="ui segment form-segment">

        <h4 class="ui dividing header">Usuários</h4>
        
        <div class="ui form">
          <div class="fields">
            <div class="seven wide field">
              <user-picker ref="userPicker" @onPick="onPickUser" />
            </div>
          </div>
        </div>        
        
        <table v-if="hasUsers" class="ui celled selectable tablet stackable table animated fadeIn">
          <thead v-if="$isDesktop">
            <tr>
              <th>Nome</th>
              <th>Perfil</th>
              <th></th>
            </tr>  
          </thead>
          <tbody>
            <tr v-for="(user, index) in customer.users">
              <td>
                <strong class="mobile-only">Nome: </strong> {{ user.name + ' ' + user.lastName }}                  
              </td>
              <td>
                <strong class="mobile-only">Perfil: </strong> 
                <user-group-icon :group="user.group" />
                {{ user.groupName }}                  
              </td>
              <td style="width: 50px;">
                <button class="ui small icon button" @click="customer.users.splice(index, 1)">
                  <i class="times icon"></i>
                </button>
              </td>
            </tr>                
          </tbody>
        </table>

        <p v-else class="grey text m-t-20 animated fadeIn">
          <i class="info circle icon"></i> Nenhum usuário associado
        </p>

      </div>

      <div class="ui segment form-segment">
        
        <h4 class="ui dividing header">Logotipo</h4>

        <p v-show="isCreating" class="grey text m-t-20">
          <i class="info circle icon"></i> Confirme a criação da clínica antes de definir um logotipo
        </p>

        <div v-show="isUpdating" class="ui grid">

          <div class="six wide computer sixteen wide tablet sixteen wide mobile column">
            <file-upload
              ref="logoUploader"
              fileType="image"
              :singleFile="true"
              :uploadPath="`/customers/${this.customer.id}/logo`"
              :loader="loadLogo"
              sendButtonLabel="Enviar imagem"
              dragTipLabel="Você também pode arrastar a imagem aqui"
              sendingLabel="Enviando imagem..."
              noUploadedFilesLabel="Nenhuma imagem enviada"
              @onRemove="onRemoveLogo"
            />
          </div>

          <div v-show="logo.file" class="ten wide computer sixteen wide tablet sixteen wide mobile column animated fadeIn">
            <p class="grey text">
              <i class="info circle icon"></i> Configurações da imagem no PDF dos Laudos
            </p>
            <div class="ui form">
              <div class="fields">
                <div class="four wide field">
                  <label class="form-label">Linha</label>
                  <input class="integer" :value="logoLine" @blur="logoLine = $event.target.value">
                </div>                
              </div>
              <div class="fields">
                <div class="four wide field">
                  <label class="form-label">Coluna</label>
                  <input class="integer" :value="logoColumn" @blur="logoColumn = $event.target.value">
                </div>                
              </div>
              <div class="fields">
                <div class="four wide field">
                  <label class="form-label">Altura</label>
                  <input class="integer" :value="logoHeight" @blur="logoHeight = $event.target.value">
                </div>                
              </div>
              <div class="fields">
                <div class="four wide field">
                  <label class="form-label">Largura</label>
                  <input class="integer" :value="logoWidth" @blur="logoWidth = $event.target.value">
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="ui segment">

        <h4 class="ui dividing header">Financeiro</h4>
        
        <div v-show="$isAdmin()" class="ui form">
          <div class="fields">
            <div class="four wide field">
              <label class="form-label">Período de Pagamento</label>
              <select-dropdown ref="paymentPeriodDropdown" @onChange="onChangePaymentPeriod" />
            </div>
            <div class="four wide field">
              <label class="form-label">Forma de Pagamento</label>
              <select-dropdown ref="paymentTypeDropdown" @onChange="onChangePaymentType" />
            </div>
            <div class="four wide field">
              <label class="form-label">Pagamento para</label>
              <select-dropdown ref="paymentToDropdown" @onChange="onChangePaymentTo" />
            </div>
            <div class="four wide field">
              <label class="form-label">Emite NF</label>
              <select-dropdown ref="issuesInvoiceDropdown" @onChange="onChangeIssuesInvoice" />
            </div>
          </div>
          <div class="fields m-t-30">
            <div class="sixteen wide field">
              <div class="ui checkbox customer-form-checkbox">
                <input type="checkbox" tabindex="0" class="hidden" v-model="customer.moneyAuto">
                <label>Preencher automaticamente o valor das parcelas quando possuir valor em dinheiro definido</label>
              </div>                
            </div>
          </div>
        </div>

        <div v-if="!$isAdmin()" class="ui form">
          <div class="fields">
            <div class="four wide field">
              <label class="form-label">Período de Pagamento</label>
              {{ paymentPeriod.description }}
            </div>
            <div class="four wide field">
              <label class="form-label">Forma de Pagamento</label>
              <i :class="paymentType.icon"></i>
              {{ paymentType.description }}
            </div>      
            <div class="four wide field">
              <label class="form-label">Pagamento para</label>
              {{ paymentToLabel }}
            </div>
            <div class="four wide field">
              <label class="form-label">Emite NF</label>
              {{ issuesInvoiceLabel }}
            </div>      
          </div>
        </div>

      </div> 

      <div class="ui segment payment-cond-segment">
        
        <h4 class="ui dividing header">Condição de Pagamento</h4>

        <div class="ui form m-t-25">          
          <div class="ui radio checkbox customer-form-checkbox" @change="onChangePaymentCond()">
            <input type="radio" class="hidden" value="weekly" v-model="customer.paymentCond">
            <label>Semanal</label>
          </div>        
          <div class="ui radio checkbox customer-form-checkbox" style="margin-left: 40px;" @change="onChangePaymentCond()">
            <input type="radio" class="hidden" value="monthly" v-model="customer.paymentCond">
            <label>Quinzenal ou Mensal</label>
          </div>
        </div>

        <div v-show="!!customer.paymentCond" class="ui form m-t-20">
          <div v-show="customer.paymentCond == 'weekly'" class="fields">
            <div class="six wide field">
              <select-dropdown ref="paymentWeekDaysDropdown" selectLabel="Selecione os dias da semana" 
                :multiple="true" @onAdd="onAddPaymentDays" @onRemove="onRemovePaymentDays" />
            </div>
          </div>
          <div v-show="customer.paymentCond == 'monthly'" class="fields">
            <div class="six wide field">
              <select-dropdown ref="paymentMonthDaysDropdown" selectLabel="Selecione os dias do mês" 
                :multiple="true" @onAdd="onAddPaymentDays" @onRemove="onRemovePaymentDays" />
            </div>
          </div>
        </div>

        <div v-show="customer.paymentCond == 'weekly'" class="ui form m-t-25">          
          <div class="ui radio checkbox customer-form-checkbox">
            <input type="radio" class="hidden" value="current" v-model="customer.weeklyPaymentRule">
            <label>Semana corrente</label>
          </div>        
          <div class="ui radio checkbox customer-form-checkbox" style="margin-left: 40px;">
            <input type="radio" class="hidden" value="next" v-model="customer.weeklyPaymentRule">
            <label>Próxima semana</label>
          </div>
          <div class="ui radio checkbox customer-form-checkbox" style="margin-left: 40px;">
            <input type="radio" class="hidden" value="subsequent" v-model="customer.weeklyPaymentRule">
            <label>Semana subsequente</label>
          </div>
        </div>

      </div>

      <div class="ui segment form-segment">

        <h4 class="ui dividing header">Serviços</h4>

        <button v-if="$isAdmin()" class="ui mini basic button" @click="$refs.serviceModal.create()">
          <i class="plus blue icon"></i> Adicionar
        </button>        
        
        <table v-if="hasServices" class="ui celled tablet stackable table animated fadeIn" :class="{ selectable: $isAdmin() }">
          <thead v-if="$isDesktop">
            <tr>
              <th>Serviço</th>
              <th>Tipo</th>
              <th>Valor</th>
              <th>Valor em Dinheiro</th>
              <th>Repasse</th>
              <th v-if="$isAdmin()"></th>
            </tr>  
          </thead>
          <tbody>
            <tr v-if="!service.removed" v-for="(service, index) in customer.services" @click="onServiceClick(index)">
              <td>
                <strong class="mobile-only">Serviço: </strong> {{ service.service.description }}                  
              </td>
              <td>
                <strong class="mobile-only">Tipo: </strong>
                <span v-html="renderServiceType(service.serviceType)"></span>
              </td>   
              <td>
                <strong class="mobile-only">Valor: </strong> R$ {{ $formatCurrency(service.value) }}   
              </td>
              <td>
                <strong class="mobile-only">Valor em Dinheiro: </strong> R$ {{ $formatCurrency(service.moneyValue) }}   
              </td>
              <td>
                <strong class="mobile-only">Repasse: </strong> R$ {{ $formatCurrency(service.payback) }}   
              </td>              
              <td v-if="$isAdmin()" style="width: 50px;">
                <button class="ui small icon button" @click="onRemoveService($event, index)">
                  <i class="times icon"></i>
                </button>
              </td>
            </tr>                
          </tbody>
        </table>

        <p v-else class="grey text m-t-20 animated fadeIn">
          <i class="info circle icon"></i> Nenhum serviço adicionado
        </p>

      </div> 

      <div class="m-t-20">
        <button class="ui basic button" @click="$historyBack()">
          <i class="reply icon"></i> Cancelar
        </button>
        <button v-if="isUpdating" class="ui basic red button m-l-10" 
          :class="{ loading: checkingRemoval || removing }" @click="onRemove()">
          <i class="trash icon"></i> Excluir
        </button> 
        <button class="ui right floated blue button" :class="{ loading: saving || checkingName }" @click="onConfirm()">
          <i class="check icon"></i> {{ isCreating ? 'Confirmar' : 'Atualizar' }}
        </button>         
      </div>

      <contact-modal ref="contactModal" @onCreate="onAddContact" @onUpdate="onUpdateContact" />
      <service-modal ref="serviceModal" @onCreate="onAddService" @onUpdate="onUpdateService" />

      <can-not-remove-modal ref="canNotRemoveModal" />

      <yes-no-modal ref="confirmRemovalModal" danger="true"
        :message="`Confirma exclusão da clínica ${customer.name} ?`" @onYes="onConfirmRemoval()" />

      <yes-no-modal ref="confirmNameModal" :message="confirmNameMessage" @onYes="saveCustomer()"/>  

    </div>
  
  </div>  
  
</template>

<script>

  import { TheMask } from "vue-the-mask"
  import { formPage, onlySimavet } from "@/mixins"
  import { BackButtonLink, FileUpload, SelectBank, SelectDropdown, SelectState, UserGroupIcon, UserPicker } from "@/components"
  import Input from "@/utils/input"
  import CustomerService from "@/services/customer-service" 
  import ZipCodeService from "@/services/zip-code-service"
  import FinancialService from "@/services/financial-service"
  import SrvService from "@/services/srv-service"
  import ContactModal from "./contact-modal"
  import ServiceModal from "./service-modal" 

  export default {
    
    name: "CustomerForm",

    mixins: [formPage, onlySimavet],

    data() {
      return {
        creatingTitle: "Nova Clínica",
        updatingTitle: "Alterar Clínica",
        indexRoute: "/entries/customers",
        service: new CustomerService(),
        customer: { person: "J", contacts: [], users: [], services: [] },
        selectedContactIndex: null,
        selectedServiceIndex: null,
        logo: {
          file: null,
          line: 0,
          column: 0,
          height: 0,
          width: 0,          
        },
        paymentPeriod: {},
        paymentType: {},
        paymentToLabel: "",
        issuesInvoiceLabel: "",
      }
    },    

    components: {
      BackButtonLink,
      FileUpload,
      SelectBank,
      SelectDropdown,
      SelectState,
      TheMask,
      UserGroupIcon,
      UserPicker,
      ContactModal,
      ServiceModal,
    },

    created() {
      
      this.initFormPage()
      this.setFinancialData()

      if (this.isUpdating)
        this.loadCustomer()      
    },    

    mounted() {      

      $(".customer-form-checkbox").checkbox()
      
      Input.maskInteger()

      if (this.isCreating)
        this.initFinancialDropdowns()      
    },

    computed: {

      hasContacts() {

        let exists = false

        for (let contact of this.customer.contacts) {
          if (!contact.removed) {
            exists = true
            break
          }  
        }

        return exists
      },

      hasServices() {

        let exists = false

        for (let service of this.customer.services) {
          if (!service.removed) {
            exists = true
            break
          }  
        }

        return exists
      },

      hasUsers() {
        return (this.customer.users.length > 0)
      },

      logoLine: {
        get() {
          return Input.integerToString(this.logo.line)
        },
        set(value) {
          this.logo.line = Input.stringToInteger(value)          
        },
      },

      logoColumn: {
        get() {
          return Input.integerToString(this.logo.column)
        },
        set(value) {
          this.logo.column = Input.stringToInteger(value)          
        },
      },

      logoHeight: {
        get() {
          return Input.integerToString(this.logo.height)
        },
        set(value) {
          this.logo.height = Input.stringToInteger(value)          
        },
      },

      logoWidth: {
        get() {
          return Input.integerToString(this.logo.width)
        },
        set(value) {
          this.logo.width = Input.stringToInteger(value)          
        },
      },
    },

    methods: {      

      setFinancialData() {

        let customer = this.customer
        const undefinedLabel = "Não definido"

        this.paymentPeriod.description = undefinedLabel
        this.paymentType.description = undefinedLabel
        this.paymentToLabel = undefinedLabel
        this.issuesInvoiceLabel = undefinedLabel

        if (customer.paymentPeriod)        
          this.paymentPeriod = FinancialService.PAYMENT_PERIOD[customer.paymentPeriod]  
          
        if (customer.paymentType)        
          this.paymentType = FinancialService.PAYMENT_TYPE[customer.paymentType]

        if (customer.paymentTo)  
          this.paymentToLabel = customer.paymentTo == "company" ? "Simavet" : "Colaborador"

        if (typeof customer.issuesInvoice == "boolean")  
          this.issuesInvoiceLabel = customer.issuesInvoice ? "Sim" : "Não"
      },

      initFinancialDropdowns() {

        const YES_NO = [
          { id: "no", description: "Não" },
          { id: "yes", description: "Sim" },    
        ]

        this.$refs.paymentPeriodDropdown.setValues(FinancialService.getPaymentPeriodList(), this.customer.paymentPeriod)        
        this.$refs.paymentToDropdown.setValues(FinancialService.getPaymentToList(), this.customer.paymentTo)
        this.$refs.issuesInvoiceDropdown.setValues(YES_NO)

        this.$refs.paymentTypeDropdown.setValues(FinancialService.getPaymentTypeList({
          hide: ["waiting_transfer"],
        }), this.customer.paymentType)

        if (typeof this.customer.issuesInvoice == "boolean")
          this.$refs.issuesInvoiceDropdown.setSelected(this.customer.issuesInvoice ? "yes" : "no")  

        this.initPaymentCondDropdowns()  
      },

      initPaymentCondDropdowns() {

        const isWeekly = (this.customer.paymentCond == "weekly")
        const isMonthly = (this.customer.paymentCond == "monthly")
        const paymentDays = this.customer.paymentDays ? this.customer.paymentDays.split(",") : []

        const weekDays = this.getWeekDays()
        const monthDays = this.getMonthDays()

        let values = []

        if (isWeekly) {

          paymentDays.forEach((day) => {
            values.push({
              id: parseInt(day),
              label: weekDays.find((el) => el.id == day).label,
            })
          })
          
          weekDays.forEach((day) => {
            if (!paymentDays.find((el) => el.id == day.id))
              values.push(day)
          })
        
        } else {

          values = weekDays
        }                  

        this.$refs.paymentWeekDaysDropdown.setValues(values, paymentDays)

        values = []

        if (isMonthly) {

          paymentDays.forEach((day) => {
            values.push({
              id: parseInt(day),
              label: day,
            })
          })

          monthDays.forEach((day) => {
            if (!paymentDays.find((el) => el.id == day.id))
              values.push(day)
          })
        
        } else {

          values = monthDays
        }

        this.$refs.paymentMonthDaysDropdown.setValues(values, paymentDays)
      },

      getWeekDays() {
        return [
          { id: 1, label: "segunda" },
          { id: 2, label: "terça" },
          { id: 3, label: "quarta" },
          { id: 4, label: "quinta" },
          { id: 5, label: "sexta" },
        ]
      },

      getMonthDays() {

        let monthDays = []

        for (let day = 1; day <= 31; day++) {
          monthDays.push({ id: day, label: day.toString() })
        }

        return monthDays
      },
      
      onChangeState(state) {        
        this.customer.state = state
        this.refreshData()
      },

      onChangeBank(bankCode) {        
        this.customer.bankCode = bankCode
        this.refreshData()
      },

      onChangePaymentPeriod(paymentPeriod) {        
        this.customer.paymentPeriod = paymentPeriod        
        this.refreshData()
      },

      onChangePaymentType(paymentType) {        
        this.customer.paymentType = paymentType        
        this.refreshData()
      },

      onChangePaymentTo(paymentTo) {        
        this.customer.paymentTo = paymentTo        
        this.refreshData()
      },

      onChangePaymentCond() {
        this.customer.paymentDays = ""  
        this.customer.weeklyPaymentRule = ""
        this.$refs.paymentWeekDaysDropdown.setValues(this.getWeekDays())    
        this.$refs.paymentMonthDaysDropdown.setValues(this.getMonthDays())
      },

      onAddPaymentDays(id) {

        if (this.loading)
          return

        if (this.customer.paymentDays)
          this.customer.paymentDays += ","

        this.customer.paymentDays += id.toString().trim()

        this.refreshData()
      },

      onRemovePaymentDays(id) {
        
        const paymentDays = this.customer.paymentDays.split(",").filter((day) => day != id)

        this.customer.paymentDays = paymentDays.toString()

        this.refreshData()
      },

      onChangeIssuesInvoice(id) {
        this.customer.issuesInvoice = (id == "yes")
        this.refreshData()
      },

      refreshData() {
        this.customer = this.$cloneObject(this.customer)
      },

      async loadAddressByZipCode() {

        if (!this.customer.zipCode || this.customer.zipCode.trim().length < 8)
          return
        
        try {

          const data = await ZipCodeService.fetch(this.customer.zipCode)

          if (!data || data.erro)
            return

          this.customer.address = data.logradouro.toUpperCase()
          this.customer.district = data.bairro.toUpperCase()
          this.customer.city = data.localidade.toUpperCase()

          this.$refs.selectState.setSelected(data.uf)          
          
        } catch (error) {
          
          this.$errorHandler(error)
        }
      },

      async loadCustomer() {

        this.loading = true

        try {

          this.customer = await this.service.findById(this.$route.params.id)

          if (this.customer.logo) {
            this.logo.line = this.customer.logo.line
            this.logo.column = this.customer.logo.column
            this.logo.height = this.customer.logo.height
            this.logo.width = this.customer.logo.width
          }
          
          this.$refs.selectState.setSelected(this.customer.state)
          this.$refs.selectBank.setSelected(this.customer.bankCode)

          this.$refs.logoUploader.loadFiles()
          
          this.initFinancialDropdowns()
          this.setFinancialData()

        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.loading = false
        }
      },

      onContactClick(index) {

        this.selectedContactIndex = index
        
        this.$refs.contactModal.update(this.customer.contacts[index])
      },

      onAddContact(contact) {
        this.customer.contacts.push(contact)
      },  

      onUpdateContact(contact) {

        let contacts = this.customer.contacts.slice()

        contacts[this.selectedContactIndex] = contact

        this.customer.contacts = contacts.slice()
      },

      onRemoveContact($event, index) {

        $event.stopPropagation()
        
        let contacts = this.customer.contacts.slice()

        contacts[index].removed = true

        this.customer.contacts = contacts
      },

      onServiceClick(index) {

        if (!this.$isAdmin())
          return

        this.selectedServiceIndex = index
        
        this.$refs.serviceModal.update(this.customer.services[index])
      },

      onAddService(service) {
        this.customer.services.push(service)
      },  

      onUpdateService(service) {

        let services = this.customer.services.slice()

        services[this.selectedServiceIndex] = service

        this.customer.services = services.slice()
      },

      onRemoveService($event, index) {

        $event.stopPropagation()
        
        let services = this.customer.services.slice()

        services[index].removed = true

        this.customer.services = services
      },

      renderServiceType(serviceType) {

        const typeIcon = SrvService.TYPE_ICONS[serviceType.icon]
        const label = `<i class="${typeIcon.icon}"></i> ${typeIcon.description.toUpperCase()}`

        return label
      },

      onPickUser(user) {              

        let exists = false

        this.customer.users.forEach((el) => {
          if (user.id == el.id)
            exists = true
        })

        if (exists) {
          this.$msg.info("Usuário já associado a essa clínica")
        } else {
          this.customer.users.push(this.$cloneObject(user))
        } 

        this.$refs.userPicker.clear()
      },

      async onConfirm() {

        if (this.checkingName || !this.validData())
          return

        this.checkingName = true
        this.confirmNameMessage = ""

        try {

          const customers = await this.service.checkCustomerName(this.customer.name, this.customer.shortName, this.customer.id)

          if (customers.length > 0) {
            
            this.confirmNameMessage = customers.length == 1 ? "Existe uma clínica cadastrada " : `Existem ${customers.length} clínicas cadastradas `
            this.confirmNameMessage += `com o nome informado. Confirma a `
            this.confirmNameMessage += this.isCreating ? "criação " : "alteração"
            this.confirmNameMessage += " da clínica ?"

            this.$refs.confirmNameModal.show()
          
          } else {

            this.saveCustomer()
          }
          
        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.checkingName = false
        }
      },

      async saveCustomer() {

        this.saving = true

        try {

          if (this.logo.file) {
            this.customer.logo = {
              line: this.logo.line,
              column: this.logo.column,
              width: this.logo.width,
              height: this.logo.height,
            }
          } else {
            this.customer.logo = null
          }

          if (this.customer.person != "J")
            this.customer.cityRegistration = ""

          if (this.isCreating) {
            await this.service.create(this.customer)
          } else {
            await this.service.update(this.customer)
          }

          this.$reloadDataTables()

          this.$msg.success(this.isCreating ? "Clínica criada com sucesso" : "Clínica atualizada com sucesso")

          if (this.$route.query.historyBack && this.$route.query.historyBack == "true") {
            this.$historyBack()
          } else {
            this.goBack()
          }          

        } catch (error) {

          this.saving = false

          this.$errorHandler(error)
        }
      },

      validData() {

        let isOk = true
        let message = ""

        const { person, name, shortName } = this.customer

        if (!name) {
          message = person == "J" ? "Informe a razão social da clínica" : "Informe o nome completo da clínica"
        } else if (!shortName) {
          message = person == "J" ? "Informe o nome fantasia da clínica" : "Informe o nome reduzido da clínica"  
        }

        if (message) {
          isOk = false
          this.$msg.info(message)
        }

        return isOk
      },

      async onRemove() {

        this.checkingRemoval = true

        try {

          const data = await this.service.canRemove(this.customer)

          if (data.canRemove)  {
            this.$refs.confirmRemovalModal.show()              
          } else {
            this.$refs.canNotRemoveModal.show(data.entities)            
          }

        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.checkingRemoval = false
        }        
      },

      async onConfirmRemoval() {
        
        this.removing = true

        try {

          if (this.logo.file)
            await this.onRemoveLogo(this.logo.file)

          await this.service.remove(this.customer)

          this.$reloadDataTables()

          this.$msg.success("Clínica excluída com sucesso")

          this.goBack()

        } catch (error) {

          this.removing = false

          this.$errorHandler(error)
        }
      },

      async loadLogo() {

        try {

          this.logo.file = await this.service.getCustomerLogo(this.customer.id)

          if (!this.logo.file)
            this.logo.file = null

          if (this.logo.file && !this.customer.logo)
            this.setDefaultLogoCoordinates()               
          
        } catch (error) {
          
          this.$errorHandler(error)
        }

        return this.logo.file
      }, 

      setDefaultLogoCoordinates() {
        this.logo.line = 30
        this.logo.column = 30
        this.logo.width = 45
        this.logo.height = 45
      },

      async onRemoveLogo(image) {

        try {

          await this.service.removeCustomerLogo(this.customer.id, image) 

          this.logo.file = null          
          this.customer.logo = null
          
          this.setDefaultLogoCoordinates()

          await this.service.update(this.customer)

          this.$reloadDataTables()
          
        } catch (error) {
          
          this.$errorHandler(error)
        }
      },
    },
  }

</script>

